import { Color } from "../../maths/Color";
import { SpineOptimizeConst } from "./SpineOptimizeConst";
const QUAD_TRIANGLES = [0, 1, 2, 2, 3, 0];
export class AttachmentParse {
    constructor() {
        this.vertexCount = 0;
        this.indexCount = 0;
        this.isNormalRender = false;
        this.vertexBones = 0;
    }
    init(attachment, boneIndex, slotId, deform, slot) {
        this.slotId = slotId;
        this.sourceData = attachment;
        this.attachment = attachment.name;
        this.boneIndex = boneIndex;
        let slotColor = slot.color;
        this.blendMode = slot.blendMode;
        let color = this.color = new Color();
        let attchmentColor;
        let darkColor = slot.darkColor;
        if (attachment instanceof spine.RegionAttachment) {
            attchmentColor = attachment.color;
            let region = attachment;
            this.vertexArray = region.offset;
            this.stride = 2;
            this.indexArray = QUAD_TRIANGLES;
            this.uvs = region.uvs;
            this.textureName = region.region.page.name;
        }
        else if (attachment instanceof spine.MeshAttachment) {
            attchmentColor = attachment.color;
            let vside = SpineOptimizeConst.BONEVERTEX;
            let mesh = attachment;
            this.textureName = mesh.region.page.name;
            if (!mesh.bones || mesh.bones.length == 0) {
                if (deform && deform.length > 1) {
                    this.vertexArray = new Float32Array(deform);
                }
                else {
                    this.vertexArray = mesh.vertices;
                }
                this.stride = 2;
                this.indexArray = mesh.triangles;
                this.uvs = mesh.uvs;
            }
            else {
                if (deform && deform.length > 1) {
                    debugger;
                }
                this.stride = vside - 6;
                let vertexSize = mesh.uvs.length / 2;
                let vertexArray = this.vertexArray = new Float32Array(vertexSize * this.stride);
                this.indexArray = mesh.triangles;
                this.uvs = mesh.uvs;
                let vertices = mesh.vertices;
                let bones = mesh.bones;
                let v = 0;
                let needPoint = (vside - 6) / 4;
                this.vertexBones = needPoint;
                for (let w = 0, b = 0; w < vertexSize; w++) {
                    let n = bones[v++];
                    n += v;
                    let result = [];
                    let offset = w * this.stride;
                    let nid = 0;
                    for (; v < n; v++, b += 3, nid++) {
                        result.push([vertices[b], vertices[b + 1], vertices[b + 2], bones[v]]);
                    }
                    if (result.length > needPoint) {
                        this.vertexBones = Math.max(this.vertexBones, result.length);
                        result.length = needPoint;
                        this.isNormalRender = true;
                    }
                    for (let i = 0; i < needPoint; i++) {
                        let v = result[i];
                        if (!v)
                            continue;
                        vertexArray[offset + i * 4] = v[0];
                        vertexArray[offset + i * 4 + 1] = v[1];
                        vertexArray[offset + i * 4 + 2] = v[2];
                        vertexArray[offset + i * 4 + 3] = v[3];
                    }
                }
            }
        }
        else if (attachment instanceof spine.ClippingAttachment) {
            this.attachment = null;
            this.isClip = true;
        }
        else if (attachment instanceof spine.PathAttachment) {
            this.attachment = attachment.name;
            this.vertexArray = new Float32Array(attachment.vertices);
            this.isPath = true;
        }
        else {
            this.attachment = null;
        }
        if (this.textureName) {
            this.vertexCount = this.vertexArray.length / this.stride;
            this.indexCount = this.indexArray.length;
        }
        if (attchmentColor) {
            this.lightColor = attchmentColor;
            color.r = slotColor.r * attchmentColor.r;
            color.g = slotColor.g * attchmentColor.g;
            color.b = slotColor.b * attchmentColor.b;
            color.a = slotColor.a * attchmentColor.a;
        }
        this.darkColor = darkColor;
        return true;
    }
}
